<template>
    <div class="section-root" ref="split">
        <Split v-model="split1" @on-move-start="isPointer = true" @on-move-end="isPointer = false" min="50" >
            <div slot="left" class="left-box">
                    <div class="top-bar">
                        <div  class="top-bar">
                            <a :href="homeUrl" class="home-btn" @click="goHome">
                                <img src="https://static.shiyanlou.com/frontend/dist/img/9f0571e.png">
                            </a>
                            <span class="course-name">{{cur_subsection_info.name}}</span>
                            <!--                    <div  class="sections-list-btn">-->
                            <!--                        <img  src="https://static.shiyanlou.com/frontend/dist/img/01a1ffb.svg">章节列表-->
                            <!--                    </div>-->
                        </div>
                    </div>
                    <div  class="box-container relative">
                        <div class="left-bar">
                            <div  class="left-bar">
                                <div class="menu-tabs">
                                    <div class="item font-16" :class="cur_tabs == 'document'? 'active': ''" @click="tabsChange('document')">实验手册</div>
<!--                                    <div class="item font-16" :class="cur_tabs == 'editor'? 'active': ''"  @click="tabsChange('editor')">实验报告</div>-->
                                    <div class="item font-16" :class="cur_tabs == 'dataSet'? 'active': ''"  @click="tabsChange('dataSet')" v-if="cur_subsection_info.hasOwnProperty('datasets_info') ?  cur_subsection_info.datasets_info.length > 0 : false">我的数据集</div>
<!--                                                                <div class="item font-16">讨论</div>-->
                                </div>
                                <div class="menu-btns"></div>
                            </div>
                        </div>
                        <div class="box-content relative full-width">
                            <div  class="lab-document" >
                                <div class="steps-document" width="648" style="height: 100%;">
                                    <div  class="step-content">
<!--                                        <div class="title">-->
<!--                                            <i class="fa fa-angle-left"></i>-->
<!--                                            <div >哈哈哈哈哈哈</div>-->
<!--                                            <i data-v-1fd30953="" class="fa fa-angle-right"></i>-->
<!--                                        </div>-->
                                        <div class="body-box" ref="markdownDody" id="markdownDody">


                                            <div class="body-con" v-show="cur_tabs == 'document'" v-if="documentGroupList.length > 0">
                                                <!-- markdown编辑器 -->
                                                <VueMarkDown :source="documentGroupList[nextIdx].document" v-if="documentGroupList[nextIdx].data_type == 1"></VueMarkDown>
                                                <!-- 富文本编辑器 -->
                                                <ckeditor-view class="body-con" v-highlight v-if="documentGroupList[nextIdx].data_type == 5" :content="documentGroupList[nextIdx].document"></ckeditor-view>
                                                <!-- 图片点击放大dom -->
                                                <div id="outerdiv" style="position:fixed;top:0;left:0;background:rgba(0,0,0,0.7);z-index:20;width:100%;height:100%;display:none;">
                                                    <div id="innerdiv" style="position:absolute;">
                                                        <img id="bigimg" style="border:5px solid #fff;" src="" />
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-show="cur_tabs == 'editor'" style="height: 100%">
                                                <MarkdownEditor class="publish_markdown_editor"
                                                                :placeholder="'写点什么吧....'"
                                                                :preview="preview"
                                                                @text="get_content">
                                                </MarkdownEditor>
                                            </div>

                                            <div v-show="cur_tabs == 'dataSet'" style="height: 100%">

                                                <Collapse accordion style="width: 100%">
                                                    <Panel name="1" v-for="(item,idx) in cur_subsection_info.datasets_info" :name="idx.toString()">
                                                        {{item.name}}
                                                        <p slot="content">
                                                            <List>
                                                                <ListItem v-for="(value) in item.files" @click.native="copyPath(item.mount_path,value.name)" style="cursor:pointer">{{value.name}}</ListItem>
                                                            </List>
                                                        </p>
                                                    </Panel>
                                                </Collapse>
                                            </div>




                                        </div>
                                    </div>
                                    <div  class="tools">
                                        <div style="text-align: right;width: 100%" v-if="documentGroupList">
                                            <Button  shape="circle" style="margin-right: 10px" @click="prev" v-show="nextIdx>0 && cur_tabs === 'document'">上一步</Button>
                                            <Button
                                                    type="primary"
                                                    shape="circle"
                                                    @click="next"
                                                    v-show="nextIdx>=0 && cur_tabs === 'document' && nextIdx !== documentGroupList.length-1"
                                            >下一步</Button>
                                            <Button type="primary" shape="circle" @click="saveEditor" v-show="cur_tabs == 'editor'">提交</Button>
                                            <Button  shape="circle" type="primary" style="margin-right: 10px" @click="close" v-show="nextIdx == documentGroupList.length-1 && cur_tabs === 'document'">关闭</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
            <div slot="right" v-if="cur_subsection_info.lab_type !== 0">
                <div class="right-box" :class="isPointer ? 'is-pointer' : ''">
                    <div v-if="cur_subsection_info.lab_type == 2" style="height: 100%">
                        <link-env :fileurl="cur_subsection_info.lab_link"></link-env>
                    </div>
                    <div class="env" v-if="cur_subsection_info.lab_type == 1 && cur_subsection_info.image_info.id > 0">
                        <div v-show="isEnvShow">
                            <div class="title">
                                <p>请点击运行环境</p><br />
                                <p style="font-size:20px;">个人空间： <span style="color:green;">/home/ilab</span></p>
                            </div>
                            <Row :gutter="30">
                                <Col span="24">
                                    <div  class="env-items" v-if="course_agent_info.domain_name !== '' ">
                                        <div class="env-item" @click="goEnv(cur_subsection_info.image_info.platform.type,cur_subsection_info.image_info.img_type)">
                                            <div class="icon">
                                                <Icon :type="cur_subsection_info.image_info.platform.icon" size="70"/>
                                            </div>
                                            <div class="env-title">{{cur_subsection_info.image_info.platform.name}}</div>
                                        </div>
                                    </div>
                                </Col>
<!--                                <Col :span="24/cur_subsection_info.labs.length" v-for="(item, index) in cur_subsection_info.labs" :key="index">-->
<!--                                    <div  class="env-items">-->
<!--                                        <div class="env-item" @click="goEnv(envArr[item.platform.type].title,item.lab.img_type)">-->
<!--                                            <div class="icon">-->
<!--                                                <Icon :type="item.platform.icon" size="70"/>-->
<!--                                            </div>-->
<!--                                            <div class="env-title">{{item.platform.name}}</div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </Col>-->
                            </Row>
                        </div>
                        <component :is="currentView" :appraisalinfo = "appraisalInfo" :currentImgType="currentImgType" :domain_name="course_agent_info.domain_name" :key="currentImgType" v-if="course_agent_info.domain_name !=='' "></component>
                    </div>
                </div>
            </div>
        </Split>
        <Modal
                title="关闭"
                v-model="modal"
                width="400"
                :styles="{top: '20px'}"
                @on-ok="ok"
        >
            <p>恭喜你！课程已学完，是否关闭当前页？</p>
        </Modal>


    </div>
</template>

<script>
    import linkEnv from "./linkEnv";
    import Env from "./env";
    import {mapActions, mapState} from "vuex";
    import $ from "jquery";
    import VueMarkDown from 'vue-markdown'
    import MarkdownEditor from '@/components/common_components/markdown_editor/markdown.vue'
    import cookie from "vue-cookies";
    import ckeditorView from "../../components/ckeditor/ckeditorView"


    export default {
        name: "scenario",
        components: {
            Env,
            MarkdownEditor,
            VueMarkDown,
            linkEnv,
            ckeditorView
        },
        data: function () {
            return {
                modal:false,
                isPointer:false,
                currentImgType:'',
                documentGroupList:[],
                fileurl:'',
                flag:'off',
                split1: 0.3,
                currentView:'',
                isEnvShow:true,
                courseMdId:this.$route.params.subsecid,
                courseid:this.$route.params.courseid,
                homeUrl:`/courses/${this.$route.params.courseid}/${this.$route.params.page}`,
                mdHtml:'',
                labAllId:parseInt(sessionStorage.getItem("lab_id")),
                lab_type:sessionStorage.getItem("lab_type"),
                preview: false,
                cur_tabs:'document',
                content:'',
                access_token:cookie.get('session'),
                nextIdx:0,
                appraisalInfo:{
                    show:false,
                    code:0,
                    courseMdId:0,
                    user_status:0
                },
            }
        },
        computed: {
            ...mapState({
                cur_subsection_info: state => state.courseManage.cur_subsection_info,
                course_agent_info:state=>state.course.course_agent_info,
            }),
            showToolBar(state) {
                if (state.currentView == '' ) {
                    return false
                } else {
                    return true
                }
            }
        },
        methods: {
            ...mapActions({
                getSubsection:'courseManage/getSubsection',
                getCourseAgentInfo: 'course/get_course_agent_info',
                getCourseAppraisalInfo:'appraisal/getCourseAppraisalInfo',
            }),
            // 复制数据集路径
            copyPath(mount_path,name){
                let  path = mount_path + '/' + name;
                var oInput = document.createElement('input');
                oInput.value = path;
                document.body.appendChild(oInput);
                if(oInput.createTextRange) {//ie
                    oInput.select();
                }else{//firefox/chrome
                    oInput.setSelectionRange(0, oInput.value.length);
                    oInput.focus();
                };
                document.execCommand("Copy");
                oInput.className = 'oInput';
                oInput.style.display = 'none';
                this.$Message.success("复制成功");
            },
            tabsChange(type){
                this.cur_tabs = type
            },
            get_content(content) {
                this.content = content
            },
            saveEditor(){
                console.log(this.content)
            },
            goHome(){
                sessionStorage.clear();
            },
            ok(){
                let _this = this;
                if(this.labAllId !== ''){
                    $.ajax({
                        url: _this.course_agent_info.domain_name+`/agentsvc/lab/destroy/`+this.labAllId+`?access_token=${_this.access_token}`,
                        type: 'delete',
                        dataType:'json',
                        contentType:"application/json",
                        async:false, //或false,是否异步
                        success:function (data) {
                            sessionStorage.clear();
                            location.href = this.homeUrl
                        }
                    })
                }
            },
            close(){
                this.modal = true
            },
            goEnv(type,img_type){
                this.currentImgType = img_type;
                this.currentView = 'env';
                this.isEnvShow = false
            },
            screenDisplay(split){
               this.split1 = split
            },
            next(){
                if(this.nextIdx === this.documentGroupList.length-1){
                    return
                }
                this.nextIdx++;
                $('#markdownDody').scrollTop(0,0)
            },
            prev(){
                if(this.nextIdx == 0){
                    return
                }
                this.nextIdx--;
                $('#markdownDody').scrollTop(0,0)
            },
            handleSplitShrink(){
                const eWidth = this.$refs.split.clientWidth
                if(this.flag === 'off'){
                    this.flag = 'on';
                    this.split1 = 50/eWidth
                }else if(this.flag === 'on'){
                    this.flag = 'off';
                    this.split1 = 0.3
                }

            },

            initMarkDown(id){
                // this.getChangeCourseDocument(id)
                let _this = this;
                this.getSubsection({
                    subsec_id:id,
                    callback:res =>{
                        // 重新赋值 documentGroupList
                        _this.documentGroupList = [];
                        if(res.data){
                            if(_this.cur_subsection_info.lab_type == 0){
                                _this.split1 = 1;
                            }else{
                                // 请求课程详情获取agent domain_name
                                this.getCourseAgentInfo(id)
                            }


                            res.data.forEach(v=>{
                                if(v.data_type == 1 || v.data_type == 5){
                                    _this.documentGroupList.push(v);
                                }
                            })
                        }
                    }

                })
            },
            imgShow(outerdiv, innerdiv, bigimg, _this){
                var src = _this.attr("src");//获取当前点击的pimg元素中的src属性
                $(bigimg).attr("src", src);//设置#bigimg元素的src属性 
                /*获取当前点击图片的真实大小，并显示弹出层及大图*/
                $("<img/>").attr("src", src).on('load',function(){
                var windowW = $(window).width();//获取当前窗口宽度 
                var windowH = $(window).height();//获取当前窗口高度 
                var realWidth = this.width;//获取图片真实宽度 
                var realHeight = this.height;//获取图片真实高度 
                var imgWidth, imgHeight; 
                var scale = 0.8;//缩放尺寸，当图片真实宽度和高度大于窗口宽度和高度时进行缩放 
                if(realHeight>windowH*scale) {//判断图片高度 
                    imgHeight = windowH*scale;//如大于窗口高度，图片高度进行缩放 
                    imgWidth = imgHeight/realHeight*realWidth;//等比例缩放宽度 
                    if(imgWidth>windowW*scale) {//如宽度扔大于窗口宽度 
                    imgWidth = windowW*scale;//再对宽度进行缩放 
                    } 
                } else if(realWidth>windowW*scale) {//如图片高度合适，判断图片宽度 
                    imgWidth = windowW*scale;//如大于窗口宽度，图片宽度进行缩放 
                        imgHeight = imgWidth/realWidth*realHeight;//等比例缩放高度 
                } else {//如果图片真实高度和宽度都符合要求，高宽不变 
                    imgWidth = realWidth; 
                    imgHeight = realHeight;
                } 
                    $(bigimg).css("width",imgWidth);//以最终的宽度对图片缩放 
                var w = (windowW-imgWidth)/2;//计算图片与窗口左边距 
                var h = (windowH-imgHeight)/2;//计算图片与窗口上边距 
                $(innerdiv).css({"top":h, "left":w});//设置#innerdiv的top和left属性 
                $(outerdiv).fadeIn("fast");//淡入显示#outerdiv及.pimg 
                }); 
                $(outerdiv).click(function(){//再次点击淡出消失弹出层 
                $(this).fadeOut("fast"); 
                }); 
            }
        },
        mounted(){
            let _this = this;
            this.initMarkDown(this.courseMdId);
            let lab_type = this.lab_type;
            let img_type = sessionStorage.getItem("img_type");
            if(lab_type){
                this.goEnv(lab_type,img_type)
            }
            
            setTimeout(() => {
                $("img").click(function(){
                    var imgObj = $(this);//将当前的pimg元素作为_this传入函数 
                    _this.imgShow("#outerdiv", "#innerdiv", "#bigimg", imgObj);
                })
            }, 100);
        },
        created(){},
        watch:{
            course_agent_info:function (value) {
                let _this = this;
                // 获取课程下考核信息
                if(value !== undefined){
                        this.getCourseAppraisalInfo({
                        data:{
                            course_id:_this.courseid,
                            sub_id:_this.courseMdId,
                        },
                        callback:res=>{
                            _this.appraisalInfo = res;
                            _this.appraisalInfo.courseMdId = _this.courseMdId;
                            _this.appraisalInfo.show = res.user_status <= 2 ? true : false;
                            _this.appraisalInfo.user_status = res.user_status;
                        },
                        error:msg=>{
                            _this.appraisalInfo.show = false;
                        },
                    })
                }
            }
        },
        destroyed() {
        },
    }
</script>
<style lang="less">
    @import "./style/markdown";

</style>

<style scoped lang="less">
  .is-pointer{
    pointer-events: none
  }
.relative{
    position: relative;
}
.section-root{
    height: 100%;
}
.left-box{
    height: 100%;
}
.top-bar {
    height: 60px;
    background: #fff;
    border-bottom: 1px solid #eee;
}
.top-bar{
    display: flex;
    align-items: center;
    padding: 0 25px 0 10px;
}
.top-bar .home-btn{
   display: inline-block;
    bottom: 2px;
    width: 20px;
    height: 20px;
    min-width: 20px;
    margin-right: 15px;
    margin-left: 5px;
}
.top-bar .home-btn img{
    max-width: 100%;
}
.top-bar .course-name{
    /*width: calc(100% - 132px);*/
    color: #777;
    font-size: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.box-container{
    display: flex;
    height: calc(~"100% - 60px");
}
.left-bar{
    width: 50px;
    height: 100%;
    background: #fff;
    border-right: 1px solid #eee;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.left-bar .menu-tabs{
    display: flex;
    flex-direction: column;
}
.left-bar .menu-btns{
    display: flex;
    flex-direction: column;
}
.menu-tabs .item{
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 20px 18px;
    color: #666;
    cursor: pointer;
}
.menu-tabs .item.active{
    color: #fff;
    background: #029ff6;
}
.box-content {
    width: calc(~"100% - 40px");
    height: 100%;
    overflow-y: auto;
}
.lab-document{
    height: 100%;
    overflow-y: auto;
}
.step-content {
    height: calc(~"100% - 50px");
    overflow-y: auto;
}
.step-content .title{
    display: flex;
    justify-content: space-between;
    -webkit-box-align: center;
    align-items: center;
    padding: 4.5px 30px;
    color: #3a3a3a;
    background: #fff;
    font-size: 20px;
    text-align: center;
    border-bottom: 1px solid #eee;
}
.tools {
    position: absolute;
     left: 0;
    z-index: 1;
    width: 100%;
}
.tools{
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 10px 5px 20px;
    background: #fff;
    border-top: 1px solid #eee;
}


.font-16{
    font-size: 16px;
}
.right-box{
    /*padding-left: 20px;*/
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background: #383838;
}
.right-box .env{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    background: #383838;
    text-align: center;
    overflow: hidden;
}
.env .title{
    margin-bottom: 50px;
    color: #fff;
    opacity: .8;
    font-size: 24px;
}
.env-items{
    display: flex;
    justify-content: space-around;
}
.env-item {
    position: relative;
    display: inline-block;
    width: 162px;
    height: 162px;
    /*margin: 0 60px;*/
    padding: 20px;
    border: 2px solid #ffffff;
    border-radius: 3px;
    cursor: pointer;
}
.env-item:hover{
    border-color:#1479f2;
}
.env-item img{
    width: 100%;
    height: 145px;
}
.env-item .icon{
    width: 100%;
    color: #ffffff;
    margin-top: 15px;
}
.env-item .env-title {
    margin-top: 10px;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
}
    .body-box{
        display: flex;
        flex-direction: column;
        padding: 20px;
        height: calc(~"100% - 10px");
        overflow-y: auto;
        color: #24292e;
        font-size: 16px;
        line-height: 1.5;
        word-wrap: break-word;
        .body-con{
            flex-grow: 1;
        }
        /*h4{*/
        /*    margin-top: 24px;*/
        /*    margin-bottom: 16px;*/
        /*    font-weight: 600;*/
        /*    line-height: 1.25;*/
        /*}*/
        /*ol,ul,p{*/
        /*    padding-left: 2em;*/
        /*    margin-top: 0;*/
        /*    margin-bottom: 16px;*/
        /*}*/
        /* img {*/
        /*    max-width: 100%;*/
        /*    box-sizing: content-box;*/
        /*    background-color: #fff;*/
        /*}*/
    }
</style>
